import { memo } from 'react';

interface MetricCardProps {
  icon: React.ReactNode;
  value: React.ReactNode;
  label: string;
  colorClass?: string;
}

const MetricCard = memo(({
  icon,
  value,
  label,
  colorClass = 'from-blue-500 to-blue-400',
}: MetricCardProps) => (
  <div
    className="flex items-center gap-4 p-5 bg-white rounded-2xl
               border border-blue-100 shadow-sm
               hover:-translate-y-1 hover:shadow-lg transition-all duration-200"
  >
    <div
      className={`w-11 h-11 rounded-xl flex items-center justify-center
                  text-white text-lg flex-shrink-0
                  bg-gradient-to-br ${colorClass} shadow-md`}
    >
      {icon}
    </div>
    <div>
      <div className="text-2xl font-bold text-blue-950 leading-tight">{value}</div>
      <div className="text-xs text-slate-400 font-medium mt-0.5">{label}</div>
    </div>
  </div>
));

MetricCard.displayName = 'MetricCard';

export default MetricCard;